import React, { useEffect, useState } from "react";
import "../Styles/Home.css";
import Footer from "../Core/Footer";
import { useLocation, useNavigate } from "react-router";
import whatsapp from "../../Assets/whatsapp-873316_1280.png";
import { Link } from "react-router-dom";
import {
  CategoryDetails,
  getProfile,
  ResturentDetails,
  SliderDetails,
} from "../Services/Operations/ProductAPI";
import { useSelector } from "react-redux";
import { IoSearchSharp } from "react-icons/io5";
import { IoIosStar } from "react-icons/io";
import { MdOutlineWatchLater } from "react-icons/md";
import { IoWalletOutline } from "react-icons/io5";

const Home = () => {
  const token = useSelector((state) => state.user.token);
  const user_id = useSelector((state) => state.user.userId);
  const navigation = useNavigate();

  const [resturent, setResturent] = useState([]);
  const [slides, setSlides] = useState([]);
  const [user, setUser] = useState([]);
  const [category, setCategory] = useState([]);

  const BASE_URL = "https://zotpot.in";

  const [location, setLocation] = useState({
    latitude: null,
    longitude: null,
    error: null,
  });

  const { state } = useLocation();
  const passedLatitude = state?.latitude;
  const passedLongitude = state?.longitude;

  useEffect(() => {
    const getLocation = async () => {
      try {
        if (passedLatitude && passedLongitude) {
          console.log("saifu.......");
          setUser("Arambag");
          setLocation({
            latitude: passedLatitude,
            longitude: passedLongitude,
            error: null,
          });
        } else {
          console.log("saifudd.......");
          const formData = new FormData();
          formData.append("token", token);
          formData.append("user_id", user_id);

          const response3 = await getProfile(formData);

          if (!response3.data.default_address) {
            console.log("saifuddinDon.......");
            const longitude = 87.78345447;
            const latitude = 22.88759098;
            setUser("Arambag");
            setLocation({ latitude, longitude, error: null });
          } else {
            console.log("saifuddin.......");
            const { latitude, longitude } = response3.data.default_address;
            setUser(
              response3.data.default_address.address || "Unknown Address"
            );
            setLocation({ latitude, longitude, error: null });
          }

          // if (response3.data.default_address) {
          //   console.log("saifuddin.......")
          //   const { latitude, longitude } = response3.data.default_address;
          //   setUser(response3.data.default_address.address || "Unknown Address");
          //   setLocation({ latitude, longitude, error: null });
          // } else {
          //   console.log("saifuddinDon.......")
          //   const longitude = 87.78345447;
          //   const latitude = 22.88759098;
          //   setUser("Arambag");
          //   setLocation({ latitude, longitude, error: null });
          // }
        }
      } catch (error) {
        console.log("..........");
        const longitude = 87.78345447;
        const latitude = 22.88759098;
        setLocation({
          latitude: latitude,
          longitude: longitude,
        });
        setUser("Arambag");
      }
    };

    getLocation();
  }, [token, user_id, passedLatitude, passedLongitude]);

  // useEffect(() => {
  //   const fetchInformation = async () => {
  //     try {
  //       const formData = new FormData();
  //       formData.append("token", token);
  //       formData.append("user_id", user_id);

  //       const response3 = await getProfile(formData);
  //       setUser(response3.data.default_address.address || "Unknown Address");
  //     } catch (error) {
  //       console.error("Error fetching details:", error);
  //     }
  //   };
  //   fetchInformation();
  // }, [token, user_id]);

  useEffect(() => {
    const fetchResturent = async () => {
      try {
        const formData = new FormData();
        console.log("latitude resturent : ", location.latitude);
        console.log("latitude resturent : ", location.longitude);
        formData.append("longitude", location.longitude || 0);
        formData.append("latitude", location.latitude || 0);

        const response = await ResturentDetails(formData);
        const response1 = await SliderDetails(formData);
        const response2 = await CategoryDetails(formData);
        console.log("resturent list : ", response);
        setResturent(response || []);
        setSlides(response1?.mainSlides || []);
        setCategory(response2 || []);
      } catch (error) {
        console.error("Error fetching restaurant details:", error);
      }
    };
    fetchResturent();
  }, [location]);

  const handleStoreClick = (store) => {
    const longitude = location.longitude;
    const latitude = location.latitude;
    navigation("/page-details", { state: { longitude, latitude, store } });
  };

  const handleResturent = (categoryName) => {
    const longitude = location.longitude;
    const latitude = location.latitude;
    const categories_ids = categoryName.categories_ids;
    navigation("/restuarents", {
      state: { longitude, latitude, categories_ids },
    });
  };

  return (
    <div className="app-container">
      <div className="home-whatsapp-wrapper">
        <Link to="https://wa.me/+918100098024">
          <img className="whatsapp-img" src={whatsapp} width="50" alt="..." />
        </Link>
      </div>
      <header className="header">
        <div className="logo">
          <Link to="/">
            <img
              style={{ width: "72px" }}
              src={require("../../Assets/zotpot.png")}
              alt="ZotPot"
            />
          </Link>
        </div>
        <div
          className="location"
          style={{
            maxWidth: "169px",
            fontSize: "15px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
          onClick={() => navigation("/search-location")}
        >
          <span style={{ fontSize: "15px" }}> {user}</span>
        </div>
      </header>
      <div style={{ padding: "20px", marginTop: "70px" }}>
        <div
          style={{
            display: "flex",
            gap: "18px",
            width: "100%",
            overflowX: "auto",
            scrollbarWidth: "none",
          }}
        >
          {slides.length > 0 &&
            slides.map((slide) => (
              <div className="home-item-image" style={{ width: "150px" }}>
                <img
                  style={{ width: "150px" }}
                  src={`${BASE_URL}${slide.data.image}`}
                  alt="slide"
                />
              </div>
            ))}
        </div>
        <div className="store-list">
          <div
            className="search"
            style={{ position: "relative", width: "95%" }}
          >
            <input
              className="input"
              type="text"
              placeholder="Search for stores or items..."
              onClick={() => navigation('/explore')}
            />
            <IoSearchSharp
              style={{
                position: "absolute",
                top: "13px",
                right: "-9px",
                fontSize: "21px",
              }}
            />
          </div>
        </div>
        <div style={{ marginTop: "33px" }}>
          {resturent.length > 0 && (
            <p style={{ fontWeight: "bold" }}>41 FOOD STORES NEAR YOU</p>
          )}
          <div
            style={{
              display: "flex",
              gap: "18px",
              marginTop: "33px",
              marginBottom: "22px",
              width: "100%",
              overflowX: "auto",
              scrollbarWidth: "none",
            }}
          >
            {category.length > 0 &&
              category.map((cat) => (
                <div className="home-item-image1" key={cat.id}>
                  <img
                    style={{ width: "110px" }}
                    src={`${BASE_URL}${cat.image}`}
                    alt={cat.name}
                    onClick={() => handleResturent(cat)}
                  />
                  <p>{cat.name}</p>
                </div>
              ))}
          </div>
        </div>
        <div className="stores-grid">
          {resturent.length > 0 ? (
            resturent.map((store) => (
              <div
                style={{ height: "100px", textAlign: "left" }}
                className="store-item"
                key={store.id}
                onClick={() => handleStoreClick(store)}
              >
                <img
                  style={{
                    width: "105px",
                    backgroundColor:
                    store.is_active === 1 ? "transparent" : "black",
                    filter: store.is_active !== 1 ? "grayscale(100%)" : "none",
                  }}
                  src={`${BASE_URL}${store.image}`}
                  alt={store.name}
                />

                <div
                  style={{
                    width: "100%",
                    marginLeft: "20px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                  }}
                >
                  <h5
                    style={{
                      margin: "0px",
                      fontSize: "14px",
                      fontWeight: "bold",
                    }}
                  >
                    {store.name}
                  </h5>
                  <p style={{ margin: "8px 0px", fontSize: "14px" }}>
                    {store.description}
                  </p>
                  {store.is_active !== 1 && <p style={{color:"orangered",marginBottom:"5px"}}>Open will be soon...</p>}
                  <div className="store-details">
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      <IoIosStar style={{ color: "orangered" }} />
                      {store.rating}
                    </span>
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      <MdOutlineWatchLater />
                      {store.delivery_time}min
                    </span>
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      <IoWalletOutline />₹{store.price_range}
                    </span>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p>No stores available</p>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Home;
